/**
 * CatererController
 * Manage Caterers
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('CatererController', ['$scope','$window','Caterer', function($scope, $window, Caterer){
  /**
   * Initial State of Scope
   */
  $scope.caterers = [];
  $scope.results  = false;

  // SearchForm
  $scope.formData = {
    content_disabled:false,
    scopes:{}
  };


  /**
   * Remote Search for Resource
   *
   */
  $scope.search = function(p){

    // Form data
    var form = $scope.formData || {};

    // Initial State of Caterers
    $scope.caterers = [];

    // Initial Page Number
    form.page = p || 1

    // Disable search form
    form.content_disabled = true;

    // Injuected resource Hcp will handle the search
    Caterer.get(form, function(response){
        $scope.results  = response;

        // Push the item ito the array of HCPs
        $scope.caterers     = response.data || [];

        // Enable the form
        $scope.formData.content_disabled = false;
    }, function($error){
        _.each($error.data, function(error){
            $.publish('resource.error', error);
        });
    });
  }


  /**
   * Return the Caterer to the upper scope, whaever it may be
   *
   * @param  Hcp    hcp
   * @param  string as
   * @return Void
   */
  $scope.pushToParent = function(resource, as){
    $scope.$parent[as] = resource;
  }

  // init the Caterers on first load
  // $scope.caterers = $scope.search();

}]);
